import React from "react";

export const Courses = (props) => {
  return (
    <div id="courses">
      <div className="container">
        <div className="section-title text-center">
          <h2>Courses</h2>
          <p>
            We are committed to empowering professionals with the skills they need to stay ahead in an ever-evolving digital landscape. Our comprehensive range of technical courses is designed to provide in-depth knowledge and hands-on experience in key areas of technology.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                  <div className="course-card">
                    <div className="course-card-inner">
                      <div className="course-card-front">
                        <h3>{d.title}</h3>
                      </div>
                      <div className="course-card-back">
                        <p>{d.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};